import React, { useEffect, useState } from "react";
import styles from "./contactSavedChat.module.scss";
import moment from "moment";
import { Divider, Modal, Tooltip } from "antd";
import { URInput } from "../../../../shared/widgets/input";
import ChatLike from "../../../chat/chatWidgets/chatLike";
import notesimg from "../../../../styles/images/notessvg.svg";
import eventimg from "../../../../styles/images/eventsvg.svg";
import taskimg from "../../../../styles/images/tasksvg.svg";
import usercircle from "../../../../styles/images/user-circle.svg";
import {
  chatwindowDetails,
  contactwindowDetails, initialStateModel, LoginState
} from "../../../../models/model";
import iconarrow from "../../../../styles/images/viewarrow.svg";
import { ChatService } from "../../../../base/chatService";
import { Cookie, getFileSize, getGroupDateFormat, googleDriveMimeFormat, urlify } from "../../../../base/utils";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { useSelector } from "react-redux";
import {
  excelFormats, pptFormats, wordFormats, zipFormats,
  mp3Formats, pdfFormats, imageFormat, videoFormat
} from "../../../../base/utils";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import iconpdf from "../../../../styles/images/filepdf.svg";
import iconppt from "../../../../styles/images/fileppt.svg";
import iconword from "../../../../styles/images/fileword.svg";
import iconxls from "../../../../styles/images/fileexcel.svg";
import iconnotsupport from "../../../../styles/images/hiddenimage.svg";
import iconzip from "../../../../styles/images/filezip.svg";
import iconotsupport from "../../../../styles/images/hiddenimage.svg";
import { URChatLeftSkeleton } from "../../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import NotFound from "../../../../styles/images/empty_states/savedchat_empty_state.svg";
import NoContent from "../../../../shared/widgets/noContent";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import { SocketChatService } from "../../../../base/socketChatService";
import { generateChatID, likeCommonFunction, paginationContactSave, saveChatCommonFunction, userInfo } from "../../../../base/socketChatService/utils";
import _ from "lodash";
import { HighlightInner } from "../../rightsidebar/highlight";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import { PriorityBeam } from "../../../../shared/widgets/priorityBeam";
import { useRef } from "react";
import ChatEventsInner from "../../../chat/chatWidgets/chatEventInner";
import ChatTaskInner from "../../../chat/chatWidgets/chatTaskInner";
import ChatNotesInner from "../../../chat/chatWidgets/chatNotesInner";
import { log } from "console";
//import { useHistory } from "react-router-dom";


type SavedPageState = {
  searchSaved: any;
  filterKey: string;
  isSearch: boolean;
  limit: number;
  searchKey: string
  isModalDelete: boolean;
  deleteObject: any;
}

export default function ContactSavedChat(props: any) {
  let { contactWindowDetails, contactSavedChatList, isContactSavedChat,
    isSaveChatLoad }: contactwindowDetails = useSelector((state: initialStateModel) => state.contactWindowReducer);
  //const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);

  const [savedList, setsavedList] = useState<SavedPageState>({
    searchSaved: [],
    filterKey: "", isSearch: false, limit: 5, searchKey: '', isModalDelete: false, deleteObject: {}
  });

  let { isMySpace }: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  //const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const socketChat = useRef<any>(null);
  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, [])

  useEffect(() => {
    if (isMySpace && window.location.pathname === "/chats") {
      let savedListMyspace = {
        offset: 40, orderType: 0, id: ""
      };
      socketChat.current.mySpaceSaved(savedListMyspace);

    }
    else {
      let savedListInput = {
        chatId: contactWindowDetails.chatId, offset: 15, orderType: 0, id: ""
      };
      socketChat.current.savedChatlistSingleUser(savedListInput);

    }

  }, [contactWindowDetails]);

  const handleScroll = (e: any) => {

    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {

      if (isMySpace && window.location.pathname === "/chats") {
        let savedListMyspace = {
          offset: 30, orderType: 0,
          id: contactSavedChatList.length >= 0 ? contactSavedChatList[contactSavedChatList.length - 1].id : ''
        };
        socketChat.current.mySpaceSaved(savedListMyspace);
        paginationContactSave("fromsavechat");
      }
      else {
        let savedListInput = {
          chatId: contactWindowDetails?.chatId,
          offset: 20, orderType: 0,
          id: contactSavedChatList.length >= 0 ? contactSavedChatList[contactSavedChatList.length - 1].id : ''
        };
        socketChat.current.savedChatlistSingleUser(savedListInput);
        paginationContactSave("fromsavechat");
      }
    }
  };

  const deleteModal = (deleteData: any) => {
    setsavedList({ ...savedList, isModalDelete: true, deleteObject: deleteData });
  };

  const closeDeleteModal = () => {
    setsavedList({ ...savedList, isModalDelete: false, deleteObject: {} });
  };

  const deleteSaveChat = () => {
    let { deleteObject } = savedList;

    socketChat.current.deleteForEveryone(deleteObject.id);

    let isBookmark = {
      id: deleteObject.id,
      saveStatus: 0
    };
    socketChat.current.bookMarkMesseage(isBookmark);

    toastInformation("Success! chat deleted for all", 'success');
    setsavedList({ ...savedList, isModalDelete: false, deleteObject: {} });
  };


  const searchStateValue = (e: any) => {

    setsavedList({ ...savedList, searchKey: e.target.value });
  };
  const search = (str: any) => {
    let searchText = str.toLowerCase();
    return _.filter(contactSavedChatList, function (data: any) {

      let saveMessageBody = (data.message.messageType === "NOTE" || data.message.messageType === "TASK" || data.message.messageType === "EVENTS") ?
        data?.message?.body?.summary?.trim() : (data.message.messageType === "FILE" || data.message.messageType === "IMAGE") ?
          (data.message.body.fileName || "") : data.message.messageType === "GEO" ? "" : data.message.body;
      let sender = data.fromDetails?.caller_id || '';
      let toTeam = (data.toDetails?.caller_id ? data.toDetails?.caller_id : data.toDetails?.team_name) || '';
      let Datesearch = moment(new Date(parseInt(data.sourceTimestamp))).format("ddd, MMM DD YYYY") || '';

      return ((saveMessageBody && ((saveMessageBody)?.toLowerCase()).includes(searchText)) ||
        (sender).toLowerCase().includes(searchText) || (toTeam).toLowerCase().includes(searchText) ||
        (Datesearch.toString()).toLowerCase().includes(searchText));
    });

  };

  const createNotes = (data: any, contact: any) => {
    //let messageBody = data.message.body;
    var parseData = data;
    if (data.messageType === "TASKS") {
      var test = JSON.parse(data.body_text);
      test['body_text'] = test.msgid;
      parseData = test;
    }
    if (!_.isUndefined(contact)) {
      let contactskey = Object.keys(contact);
      if (!_.isUndefined(contactskey) && contactskey.length === 1) { return; }
      else {
        var chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);

        let chatDetail = { chatId: generateChatID(userInfo().fromID, contact?.sip_login_id ? contact?.sip_login_id.toString() : contact?.team_id.toString()) };
        chatService.openChatWindow(contact, '', chatDetail);
        let dataRes: any = { chatId: data?.chatId, "id": data.id }
        chatService.Savehistory(dataRes);
        setTimeout(() => {
          ChatService.saveChatHighlight(true, parseData);
        }, 500)

      }
    }

  };
  const openLink = (url: any) => {
    if (!url.includes("http")) url = "https://" + url;
    window.open(url);
  };

  let response: any = search(savedList.searchKey);

  let result: any = _(response)
    .groupBy((o: any) => (o.timestamp &&
      moment(o.timestamp).format('DD MMM YYYY')))
    .map((contacts: any, letter: any) => ({ letter, contacts })).reverse()
    .value();

  const IsJsonString = (str: any) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };


  return (
    <>

      <div className={styles.savedSec}>
        <div className={`${styles.middlelayertop} ${styles.rightfiltersearch}`}>
          <URInput placeHolder="Search" className={`customFocused ${styles.rightbarsearch}`} onChange={(e: any) => searchStateValue(e)} />
        </div>
        {((contactSavedChatList.length === 0 && isContactSavedChat) || result.length === 0) && <NoContent image={NotFound}
          title={"Worktual Saved Chats"}
          description={<>Let us refresh your memory. Save all your important<br />
            conversations here.</>} />}
        {!isContactSavedChat && <Lottie className="svgLoading"
         animationData={ContactLoader}  />}
        <div className={`scroller ${styles.savedChatScroll}`} onScroll={handleScroll}>


          {result && result.map((saveListdetails: any, index: any) => {
            return (
              <>
              <div className="dividercross topset"><div className="dividerLineView">{getGroupDateFormat(saveListdetails.letter)}</div></div>
                {saveListdetails.contacts && saveListdetails.contacts?.map((save: any) => {
                  let redirectUsr: any = loginDetails?.userdetails?.sip_login_id === save?.to ? save?.fromDetails : save?.toDetails;

                  let isBookmark: any = save.message?.isSave || [];
                  let LikeObeject: any = save?.message?.liked || [];
                  let isLike = (LikeObeject && LikeObeject['s' + loginDetails.userdetails.sip_login_id]) || 0;
                  let savedBookmark = (isBookmark && isBookmark['s' + loginDetails.userdetails.sip_login_id]) || 0;

                  let fileName = '';
                  let filesize = '';
                  let fileTypes = '';
                  let filePath = '';
                  let isCloudFiles = false;
                  if (save.message.messageType !== "TEXT" && (save.message.messageType === "FILE" || save.message.messageType === "IMAGE")) {
                    let messageBody = IsJsonString(save?.message?.body) ? JSON.parse(save?.message?.body) : save?.message?.body;

                    // fileName = messageBody.fileName;
                    fileName =messageBody?.fileName.length > 40 ? messageBody?.fileName.substring(0, 39) + "..." : messageBody?.fileName;
                    filesize = messageBody.filesize;
                    fileTypes = messageBody.fileType;
                    filePath = messageBody.filePath;
                    isCloudFiles = messageBody?.isCloudfiles || false;
                  }

                  let currentDate = moment(save.timestamp).calendar().includes('Today')
                    ? moment(save.timestamp).calendar()
                    : moment(save.timestamp).calendar().includes('Yesterday') ?
                      moment(save.timestamp).calendar() :
                      moment(save.timestamp).format("DD MMM") + " at " + moment(save.timestamp).format("hh:mm A");
                  let size = filesize && getFileSize(filesize);
                  return (

                    <>
                      <></>


                      <div className={styles.savedchatlist} >
        

                        <div className={styles.toplayer}>
                          <div className={styles.profiles}>
                            <URAvatarGroup className='lefts size28 colorBG1'
                              profileInfo={<>
                                {
                                  save.fromDetails?.ImageURL ?
                                    <img src={save.fromDetails?.ImageURL} alt="" /> :
                                    save.fromDetails?.profile_url ?
                                      <img src={save.fromDetails?.profile_url} alt="" />
                                      : <span>{save.fromDetails?.caller_id ? save.fromDetails?.caller_id?.charAt(0)?.toUpperCase() :'Unknown'?.charAt(0).toUpperCase()}</span>}

                                <URStatusDot className={userStatusColor(save.fromDetails?.user_status, 'small')} />


                              </>}
                            />
                          </div>
                          <h3>
                            <HighlightInner content={loginDetails.userdetails?.caller_id
                               === save.fromDetails?.caller_id ? "You" : save.fromDetails?.caller_id ? save.fromDetails?.caller_id : "Unknown User"}
                              searchedData={savedList.searchKey} />
                            <span className={`icon_strokearrowright ${styles.arrowrightclr}`} ></span>
                            <b>

                              <HighlightInner content={loginDetails.userdetails?.caller_id
                                === save.toDetails?.caller_id ? "You" : save.toDetails?.caller_id ? save.toDetails?.caller_id : save.toDetails?.team_name.length <= 24 ? save.toDetails?.team_name :
                                save.toDetails?.team_name.length > 25 ? save.toDetails?.team_name.substring(0, 25) + "..." : "Unknown User"}
                                searchedData={savedList.searchKey} />

                            </b>

                          </h3>
                        </div>
                        <div className={loginDetails.userdetails?.sip_login_id === save?.from ? `${styles.topbottomlayer} savedMsgOut` : `${styles.topbottomlayer} savedMsgIn`}>
                          <div className={mp3Formats.indexOf(fileTypes) !== -1 ?
                            `${styles.hoverdiv} ${styles.topHoverresize}` : imageFormat.indexOf(fileTypes) !== -1 ?
                              `${styles.imagehoveradjust} ${styles.hoverdiv}` : styles.hoverdiv}>
                            <ul>
                              <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, save)}><Tooltip placement="top" mouseEnterDelay={0.5}
                                title={isLike === 0 ? 'Like' : 'Unlike'}>
                                  <span className="icon_Like"></span>
                                </Tooltip></li>

                              <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, save)}><Tooltip mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ?
                                'Save Chat' : 'UnSave chat'}>
                                <span className="icon_savechatsill"></span></Tooltip></li>
                              {(save?.message?.messageType === 'TEXT' || save?.message?.messageType === 'FILE' || save?.message?.messageType === 'IMAGE'
                                || save?.message?.messageType === 'MENTION') && loginDetails.userdetails?.caller_id
                                === save.fromDetails?.caller_id && <li onClick={() => deleteModal(save)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Delete chat">
                                  <span className="icon_delete"></span></Tooltip></li>}
                            </ul>
                          </div>
                          {save?.message?.messageType === "NOTE" ? <>
                            <ChatNotesInner notesData={save?.message?.body} searchedData={''} />
                            {/* <div className={styles.noteshort} onClick={() => createNotes(save, redirectUsr)}>
                                <img src={notesimg} alt="" />
                                <div className={styles.filesDetails}>
                                  <span className={styles.fileName}>
                                    {save.message.body.summary.length > 13 ?
                                      save.message.body.summary.substring(0, 11) + "..." : save.message.body.summary}
                                  </span>
                                  <span className={styles.fileDt}>Created on {save.message.body.lastModified
                                    && moment(new Date(parseInt(save.message.body.lastModified))).format('ll')}</span>
                                </div>
                              </div> */}
                          </> : save.message.messageType === "EVENTS" ? <>
                            <ChatEventsInner eventData={save?.message?.body} searchedData={''} viewData={''} />

                            {/* <div className={styles.eventsMessage} onClick={() => createNotes(save, redirectUsr)}>
                                <span className={styles.eventsCreated}><img src={eventimg} alt="" /></span>
                                <div className={styles.eventsHeader}>
                                  <div className={styles.eventsStatus}>
                                    <span className={styles.eventsTitle}>{save.message.body.summary.length > 13 ?
                                      save.message.body.summary.substring(0, 11) + "..." : save.message.body.summary}</span>
                                  </div>
                              <div className={styles.eventsDetails}>
                                  <span className={styles.eventsDate}>Chennai long name like</span>
                                  <span className={styles.eventsDate}>
                                    {moment(save.message.body?.timestamp).format("ddd, MMM Do YYYY")} </span>
                                </div> 
                                  <div className={styles.reviewBtn}>
                                    <span className={styles.eventsDate}>
                                      {moment(save.message.body?.timestamp).format('ll')} </span>
                                    <StatusTag className='statusunderReview' name='In Review' />
                                  </div>
                                </div>
                              </div> */}
                          </> : save.message.messageType === "TASK" ? <>
                            <ChatTaskInner taskData={save?.message?.body} searchedData={''} viewData={""} />
                            {/* <div className={`${styles.taskMessage}`} onClick={() => createNotes(save, redirectUsr)}>
                                <span className={styles.taskCreated}><img src={taskimg} alt="" /></span>
                                <div className={styles.taskHeader}>
                                  <div className={styles.taskStatus}>
                                    <span className={styles.taskTitle}>{save.message.body.summary.length > 13 ?
                                      save.message.body.summary.substring(0, 11) + "..." : save.message.body.summary}</span>
                                    {save.message.body?.attendee.length > 0 &&
                                      <span className={styles.userCount}>{save.message.body.attendee.length}
                                        <img src={usercircle} alt="" /></span>}
                                  </div>
                                  <div className={styles.taskDetails}>
                                    <PriorityBeam className={save.message.body.priority ===
                                      "High" ? 'priorityBeam bgRed' : save.message.body.priority === "Medium" ?
                                      'priorityBeam bgYello' : 'priorityBeam bgGreen'} />
                                    <span className={styles.taskDate}>
                                      {currentDate}
                                    </span>
                                    <div className={styles.reviewBtn}>
                                      {save.message.body.creatorStatus === "In Review" || save.message.body?.taskStatus === "In Review" ||
                                        save.message.body?.recurOptions === "In Review" ?
                                        <StatusTag className='statusunderReview' name='In Review' />
                                        : save.message.body?.creatorStatus === "On Hold" || save.message.body?.taskStatus === "On Hold" ||
                                          save.message.body?.recurOptions === "On Hold" ?
                                          <StatusTag className='statusHold' name='On Hold' /> :
                                          save.message.body?.creatorStatus === "Completed" || save.message.body?.taskStatus === "Completed" ||
                                            save.message.body?.recurOptions === "Completed" ?
                                            <StatusTag className='statusCompleted' name='Completed' /> :
                                            <StatusTag className='statusunderinProgress' name='In Progress' />
                                      }
                                    </div>
                                  </div>

                                </div>
                              </div> */}
                          </> :
                            (save.message.messageType === "FILE" || save.message.messageType === "IMAGE") &&
                              imageFormat.indexOf(fileTypes) === -1 && videoFormat.indexOf(fileTypes) === -1 &&
                              mp3Formats.indexOf(fileTypes) === -1 ? <>
                              <div className={`${styles.savedContent} ${styles.padoverdocment}`}>

                                <div className={`msgBody ${styles.chatAttachmentList}`}>
                                  {zipFormats.indexOf(fileTypes) !== -1 && <div className={`fileContent ${styles.filesChat}`} onClick={() => createNotes(save, redirectUsr)}>
                                    <div className={styles.filesImage}>
                                      <img src={iconzip} alt="filename" /></div>
                                    <div className={styles.filesDetails}>
                                      <span className={styles.fileName}>
                                      <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                        {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                        </span>
                                      <span className={styles.fileDt}>{size + " Zip"}</span>
                                      {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                    </div>

                                  </div>
                                  }
                                  {excelFormats.indexOf(fileTypes) !== -1 &&
                                    <div className={`fileContent ${styles.filesChat}`} onClick={() => createNotes(save, redirectUsr)}>
                                      <div className={styles.filesImage}>
                                        <img src={iconxls} alt="filename" /></div>
                                      <div className={styles.filesDetails}>
                                        <span className={styles.fileName}>
                                          {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                          <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                          </span>
                                        <span className={styles.fileDt}>{size + " Excel"}</span>
                                        {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                      </div>
                                    </div>}
                                  {pdfFormats.indexOf(fileTypes) !== -1 && <div className={`fileContent ${styles.filesChat}`} onClick={() => createNotes(save, redirectUsr)}>
                                    <div className={styles.filesImage}><img src={iconpdf} alt="filename" /></div>
                                    <div className={styles.filesDetails}>
                                      <span className={styles.fileName}>
                                        {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                        <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                        </span>
                                      <span className={styles.fileDt}>{size + " Pdf"}</span>
                                      {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                    </div>
                                  </div>}
                                  {(wordFormats.indexOf(fileTypes) !== -1 || fileTypes.includes('plain') || fileTypes.includes('html')) && <div className={`fileContent ${styles.filesChat}`} onClick={() => createNotes(save)}>
                                    <div className={styles.filesImage}><img src={iconword} alt="filename" /></div>
                                    <div className={styles.filesDetails}>
                                      <span className={styles.fileName}>
                                        {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                        <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                        </span>
                                      <span className={styles.fileDt}>{size + " Word Document"}</span>
                                      {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                    </div>
                                  </div>}
                                  {pptFormats.indexOf(fileTypes) !== -1 &&
                                    <div className={`fileContent ${styles.filesChat}`} onClick={() => createNotes(save, redirectUsr)}>
                                      <div className={styles.filesImage}><img src={iconppt} alt="filename" /></div>
                                      <div className={styles.filesDetails}>
                                        <span className={styles.fileName}>
                                          {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                          <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                          </span>
                                        <span className={styles.fileDt}>{size + " Ppt"}</span>
                                        {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}

                                      </div>
                                      {/* <div className={styles.attachmentHover}>
                        <ChatAttachmentsOption previewopen={()=>{}} data={""} fromFiles={false}/></div> */}
                                    </div>}
                                  {(googleDriveMimeFormat.indexOf(fileTypes) !== -1 || fileTypes === 'application/x-msdownload') &&
                                    <div className={`msgAttach ${styles.filesChat}`}>
                                      <div className={styles.filesImage}><img src={iconnotsupport} alt="filename" /></div>
                                      <div className={styles.filesDetails}>
                                        <span className={styles.fileName}>
                                          {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                          <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                          </span>
                                        <span className={styles.fileDt}>{size}</span>
                                        {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                      </div>

                                    </div>
                                  }
                                </div>
                              </div>
                            </> : (save.message.messageType === "FILE" || save.message.messageType === "IMAGE") && mp3Formats.indexOf(fileTypes) !== -1 && !isCloudFiles ? <>
                              <div className={`${styles.savedContent} ${styles.padoverdocment}`} >

                                {mp3Formats.indexOf(fileTypes) !== -1 && <>
                                  <div className={`fileContent ${styles.audioChat}`} onClick={() => createNotes(save, redirectUsr)}>
                                    <div className={styles.audioImage}>
                                      {/* <div className={styles.convIcon}>
                                          <div className={styles.lefts}><span>D</span></div>
                                          <img src={pic} alt="" />
                                          <span className={`bgRed ${styles.statusRound}`}></span>
                                        </div> */}
                                    </div>
                                    <div className={styles.audioDetails}>
                                      <div className="audioNew">
                                        <AudioPlayer
                                          src={filePath}
                                          customIcons={{
                                            play: <span className="icon_play"></span>,
                                            pause: <span className="icon_pausebar"></span>
                                          }}
                                          customProgressBarSection={
                                            [
                                              RHAP_UI.MAIN_CONTROLS,
                                              RHAP_UI.PROGRESS_BAR

                                            ]
                                          }
                                          customControlsSection={
                                            [
                                              <div key={index}>Audio</div>,
                                              RHAP_UI.DURATION
                                            ]

                                          }
                                          timeFormat='mm:ss'


                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                                }
                              </div>
                            </> :
                              (save.message?.isLink === true && save.message.messageType === "IMAGE") &&
                                imageFormat.indexOf(fileTypes) !== -1 && !isCloudFiles ? <>
                                <div className={`msgBody ${styles.imageChat}`}>
                                  <div className={styles.imageList}>
                                    <div className={styles.imageSec} onClick={() => createNotes(save, redirectUsr)}>
                                      <img src={filePath} alt="" /></div>
                                  </div>
                                  <p className={styles.linkText} onClick={() => openLink(save.message?.body?.text && save.message?.body?.text)} > {save?.message?.body?.text && save?.message?.body?.text} </p>
                                  <div className={styles.Imagehoverdiv}>
                                    <ul>
                                      <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, save)}><Tooltip mouseEnterDelay={0.5} placement="top"
                                        title={isLike === 0 ? 'Like' : 'Unlike'}><span className="icon_Like"></span></Tooltip></li>

                                      <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, save)}><Tooltip mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ?
                                        'Save Chat' : 'UnSave chat'}>
                                        <span className="icon_savechatsill"></span></Tooltip></li>
                                      {(save?.message?.messageType === 'TEXT' || save?.message?.messageType === 'FILE' || save?.message?.messageType === 'IMAGE'
                                        || save?.message?.messageType === 'MENTION') &&
                                        <li onClick={() => deleteModal(save)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Delete chat">
                                          <span className="icon_delete"></span></Tooltip></li>}
                                    </ul>

                                  </div>
                                </div>
                              </> :
                                (save.message.messageType === "FILE" || save.message.messageType === "IMAGE") &&
                                  imageFormat.indexOf(fileTypes) !== -1 && !isCloudFiles ? <>
                                  <div className={`msgBody ${styles.imageChat}`}>
                                    <div className={styles.imageList}>
                                      <div className={styles.imageSec} onClick={() => createNotes(save, redirectUsr)}>
                                        <img src={filePath} alt="" /></div>
                                    </div>
                                    <div className={styles.Imagehoverdiv}>
                                      <ul>
                                        <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, save)}><Tooltip mouseEnterDelay={0.5} placement="top"
                                          title={isLike === 0 ? 'Like' : 'Unlike'}><span className="icon_Like"></span></Tooltip></li>

                                        <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, save)}><Tooltip mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ?
                                          'Save Chat' : 'UnSave chat'}>
                                          <span className="icon_savechatsill"></span></Tooltip></li>
                                        {(save?.message?.messageType === 'TEXT' || save?.message?.messageType === 'FILE' || save?.message?.messageType === 'IMAGE'
                                          || save?.message?.messageType === 'MENTION') &&
                                          <li onClick={() => deleteModal(save)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Delete chat">
                                            <span className="icon_delete"></span></Tooltip></li>}
                                      </ul>
                                    </div>
                                  </div></> : (save.message.messageType === "FILE" || save.message.messageType === "IMAGE") &&
                                    videoFormat.indexOf(fileTypes) !== -1 && !isCloudFiles ? <>
                                  <div className={`msgBody ${styles.savedContent} ${styles.padoverdocment}`} >
                                    {/* <span className={styles.savedText}>For you my special gift</span> */}
                                    {/* <ChatVideoPlayer fromContactSaved={true} data={save}></ChatVideoPlayer> */}
                                    <video controls>
                                      <source src={filePath} />
                                    </video>
                                  </div>
                                </>
                                  :
                                  (save.message.messageType === "FILE" || save.message.messageType === "IMAGE") &&
                                    (imageFormat.indexOf(fileTypes) !== -1 || videoFormat.indexOf(fileTypes) !== -1 ||
                                      mp3Formats.indexOf(fileTypes) !== -1) && isCloudFiles ?
                                    <div className={`msgBody ${styles.chatAttachmentList}`}>
                                      <div className={styles.filesChat} onClick={() => createNotes(save, redirectUsr)}>
                                        <div className={styles.filesImage}>
                                          <img src={iconotsupport} alt="filename" /></div>
                                        <div className={styles.filesDetails}>
                                          <span className={styles.fileName}>
                                          {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                          <HighlightInner content={fileName}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                          </span>
                                          <span className={styles.fileDt}>{size}</span>
                                          {isCloudFiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box' : " File from Drive"}</span>}
                                        </div>
                                      </div>
                                    </div>
                                    : save.message?.isLink ?
                                      <div className={`msgBody ${styles.contentTxt}`} dangerouslySetInnerHTML={{ __html: urlify(save?.message?.body) }}>
                                      </div>
                                      :
                                      save.message.messageType === "GEO" ?
                                        <div className={`msgBody ${styles.contentTxt}`}> this is geoLocation Message type</div>
                                        :
                                        <div className={`msgBody ${styles.contentTxt}`} onClick={() => createNotes(save, redirectUsr)} 
                                        // dangerouslySetInnerHTML={{ __html: save?.message?.body }}
                                        >
                                               <HighlightInner content={save?.message?.body}
                                                                  searchedData={savedList.searchKey}></HighlightInner>
                                        </div>


                          }
                          <div className={styles.userInfo}>
                            {save.message.messageType === "TASK" && <span className={styles.tasksChatContent}>
                              {save?.message?.isEdit ? "You updated the Task" : "You created a new Task"}
                            </span>}
                            {save.message.messageType === "EVENTS" && <span className={styles.tasksChatContent}>
                              {save?.message?.isEdit ? "You updated the Event" : "You created a new Event"}
                            </span>}
                            {save.message.messageType === "NOTE" && <span className={styles.tasksChatContent}>
                              {save?.message?.isEdit ? "You updated the Note" : "You created a new Note"}
                            </span>}
                            {isCloudFiles && <img className={styles.arrowlink} src={iconarrow} onClick={() => { window.open(filePath) }} alt='save' />}
                            <span className="icon_ribbonfill"></span><br />
                            <Tooltip mouseEnterDelay={0.5} placement="top" title={currentDate} >
                              <span className={styles.timeText}>
                                {moment(save?.timestamp).format('hh:mm')}
                              </span>
                            </Tooltip>
                          </div>
                          <div className="likeLeft">
                            <ChatLike className='likeRight likeSaved contmarnon' tooltipTitle={save.fromDetails?.caller_id}
                              message={save} />
                          </div>

                        </div>
                      </div>
                    </>
                  );

                })}
              </>
            )
          })}

          {isSaveChatLoad && ([1].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />)))}

        </div>

      </div>
      <Modal title="Delete selected chat"
        centered
        visible={savedList.isModalDelete}
        onOk={() => deleteSaveChat()}
        onCancel={closeDeleteModal}
        cancelText="Cancel"
        okText="Delete"
        maskClosable={false}
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete this chat
      </Modal>
    </>
  );
};
